import React from 'react';
import AboutMeNew from './tabs/AboutMeNew';

export default function MainPage() {
  return <AboutMeNew />;
}
